<template>
  <div class="component-wrapper">
    <v-btn
      icon
      color="primary"
      @click="$router.push({ path: '/superuser' })"
      class="close-button"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <div class="text-h6 text-center title-underline">
      {{ activeMuseum.defaultTitle }}
    </div>

    <v-tabs v-model="activeTab" background-color="white" fixed-tabs class="my-5"  >
      <v-tab :lang="$i18n.locale">
        <v-icon left class="mdi mdi-bank"></v-icon>
        {{ $t('editMuseum') }}
      </v-tab>
      <v-tab :lang="$i18n.locale">
        <v-icon left class="mdi mdi-account-multiple"></v-icon>
        {{ $t('users') }}
      </v-tab>
      <v-tab :lang="$i18n.locale">
        <v-icon left class="mdi mdi-notebook"></v-icon>
        {{ $t('programs') }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab" class="w-100">
      <v-tab-item>
        <div class="tab-content px-6 py-4">
          <div class="d-flex flex-column align-center">
            <MuseumTitleTranslations
              :default-locale="activeMuseum.defaultLocale"
              :edit-mode="true"
            />

            <div class="text-right mt-5">
              <v-btn
                color="primary"
                :lang="$i18n.locale"
                :loading="loader"
                @click="updateMuseum"
              >
                {{ $t('save') }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-tab-item>

      <v-tab-item>
        <div class="tab-content px-6 py-4">
          <EditMuseumUsers />
        </div>
      </v-tab-item>

      <v-tab-item>
        <div class="tab-content px-6 py-4">
          <Home />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import MuseumTitleTranslations from "@/components/MuseumTitleTranslations.vue";
  import EditMuseumUsers from "./EditMuseumUsers.vue";
  import Home from "../home/Home.vue";

  export default {
    name: "EditMuseum",
    components: {
      MuseumTitleTranslations,
      EditMuseumUsers,
      Home
    },
    computed: {
      ...mapState({
        activeMuseum: (state) => state.superuser.activeMuseum
      }),
      activeTab: {
        get() {
          return this.$store.state.superuser.activeMuseumTab
        },
        set(value) {
          this.$store.commit('setActiveMuseumTab', value);
        }
      },
    },
    data() {
      return {
        loader: false
      };
    },
    methods: {
      ...mapActions(['editMuseum', 'getMuseums', 'setActiveMuseum']),
      async updateMuseum() {
        this.loader = true;
        await this.editMuseum();
        await this.getMuseums(true);
        this.setActiveMuseum(this.activeMuseum.id);
        this.loader = false;
      }
    }
  };
</script>

<style scoped>
  .tab-content {
    min-height: 400px;
  }
</style>
